module.exports = __webpack_public_path__ + "static/media/me.763db071.png";